import React, { createContext, useContext, useState, useEffect } from 'react';

const AppContext = createContext();

export function useAppContext() {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within AppProvider');
  }
  return context;
}

export function AppProvider({ children }) {
  // User state (placeholder - will be connected to auth later)
  const [user, setUser] = useState(null);
  
  // Global settings
  const [settings, setSettings] = useState({
    timerDuration: 25, // minutes
    shortBreak: 5,
    longBreak: 15,
    notifications: true,
    soundEnabled: true,
    theme: 'light',
    notificationBlocker: {
      enabled: false,
      sites: [
        'facebook.com',
        'instagram.com',
        'twitter.com',
        'x.com',
        'tiktok.com',
        'youtube.com',
        'reddit.com',
        'linkedin.com',
        'pinterest.com',
        'snapchat.com'
      ]
    }
  });

  // Current focus session state (global across app)
  const [currentSession, setCurrentSession] = useState(null);

  // Load settings from localStorage on mount
  useEffect(() => {
    const savedSettings = localStorage.getItem('focusAppSettings');
    if (savedSettings) {
      try {
        const parsed = JSON.parse(savedSettings);
        // Merge with defaults to ensure all properties exist
        setSettings(prev => ({
          ...prev,
          ...parsed,
          notificationBlocker: parsed.notificationBlocker || prev.notificationBlocker
        }));
      } catch (error) {
        console.error('Error loading settings:', error);
      }
    }
  }, []);

  // Save settings to localStorage when they change
  useEffect(() => {
    localStorage.setItem('focusAppSettings', JSON.stringify(settings));
  }, [settings]);

  // Update a specific setting
  const updateSetting = (key, value) => {
    setSettings(prev => ({
      ...prev,
      [key]: value
    }));
  };

  // Start a new focus session
  const startSession = (sessionData) => {
    setCurrentSession({
      ...sessionData,
      startTime: Date.now(),
      status: 'active'
    });
  };

  // End the current session
  const endSession = () => {
    if (currentSession) {
      // Here you would typically save the session to database
      setCurrentSession(null);
    }
  };

  const value = {
    user,
    setUser,
    settings,
    updateSetting,
    currentSession,
    startSession,
    endSession
  };

  return (
    <AppContext.Provider value={value}>
      {children}
    </AppContext.Provider>
  );
}







